import script from "./DialogPasswordUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogPasswordUpdate.vue?vue&type=script&setup=true&lang=js"

import "./DialogPasswordUpdate.vue?vue&type=style&index=0&id=6b1cb600&lang=scss"

const __exports__ = script;

export default __exports__